/**
 * A global namespace for `load` event.
 */
const loadEvent = "load";
export default loadEvent;
